import { render } from "./LocationTips.vue?vue&type=template&id=d6803c32"
import script from "./LocationTips.vue?vue&type=script&lang=js"
export * from "./LocationTips.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__